module.exports = __webpack_public_path__ + "media/img/illustrations/quote-sign-dark-955c1a53637f01d476ef63210945b629.svg";